import backdata from './backdata';
import landing from './landing';
import classes from './classes';
import tags from './tags';
export default {
	backdata,
	landing,
	classes,
	tags
};
